import { render, staticRenderFns } from "./layerOdontograma.vue?vue&type=template&id=2203b420&scoped=true"
import script from "./layerOdontograma.vue?vue&type=script&lang=js"
export * from "./layerOdontograma.vue?vue&type=script&lang=js"
import style0 from "./layerOdontograma.vue?vue&type=style&index=0&id=2203b420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2203b420",
  null
  
)

export default component.exports